import { z } from 'zod';
import { PlanName, TenantStatus } from './enums';

/**
 * Tenant slug validation mirroring the CHECK constraint in
 * db-schema-platform.md § `tenants`:
 *   slug ~ '^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$'
 *
 * Length is 3–32 chars. Must start and end with an alphanumeric
 * character; hyphens are allowed only in the interior.
 * Reserved slugs (www, api, admin, …) are enforced separately by
 * the `reserved_slugs` table — see `@webbox/db-platform`.
 */
export const TenantSlugSchema = z
  .string()
  .min(3)
  .max(32)
  .regex(/^[a-z0-9][a-z0-9-]{1,30}[a-z0-9]$/, {
    message:
      'slug must be 3–32 chars, lowercase alphanumeric with optional internal hyphens (e.g. acme-corp)',
  });

export const TenantSchema = z.object({
  id: z.string().uuid(),
  slug: TenantSlugSchema,
  name: z.string().min(1).max(120),
  status: z.nativeEnum(TenantStatus),
  plan: z.nativeEnum(PlanName),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Tenant = z.infer<typeof TenantSchema>;
